<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>
  <!-- <site-modal ID="violationReportDeleteConfirmModal" @closed="cancelModal">
    <template #header>
      <h6>
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-trash"
          viewBox="0 0 16 16"
        >
          <path
            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
          ></path>
          <path
            fill-rule="evenodd"
            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
          ></path>
        </svg>
        حذف گزارش خطای درمانگر
      </h6>
    </template>
    <template #body>
      <validation-summery
        v-if="modalDeleteConfirmHasError"
        :errors="modalError"
      ></validation-summery>
      <p>از حذف گزارش خطای درمانگر انتخاب شده اطمینان دارید؟</p>
    </template>
    <template #footer>
      <div class="m-auto">
        <button
          class="btn btn-sm rounded btn-blueSite"
          @click="confirmedDeleteModal"
        >
          <i class="fi fi-box-checked"></i>
          تایید
        </button>
        <button class="btn btn-sm rounded btn-blueSite" @click="cancelModal">
          <i class="fi fi-close"></i>
          انصراف
        </button>
      </div>
    </template>
  </site-modal> -->

  <site-modal
    ID="addViolationReportModal"
    modalSize="medium"
    modalHeaderClass="bg-gray-700 text-yellowTheme"
    @closed="cancelModal"
  >
    <template #header>
      <div class="row">
        <h6>
          <svg
            class="float-start"
            width="18px"
            height="18px"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
          >
            <path
              d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
            ></path>
            <path
              d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
            ></path>
          </svg>
          ثبت گزارش خطای درمانگر جدید
        </h6>
      </div>
    </template>
    <template #body>
      <validation-summery
        v-if="modalHasError"
        :errors="modalError"
      ></validation-summery>
      <div class="card border-0">
        <!-- <div
          class="card-header mb-0 p-0 border-0 bg-light"
          id="cleanHeadingOne"
        >
          <h2 class="mb-0">
            <button
              class="btn btn-link w-100 btn-lg text-align-start text-decoration-none text-dark"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#shadowCollapseOne"
              aria-expanded="true"
              aria-controls="shadowCollapseOne"
            >
              <span
                ><i class="fi fi-dots-vertical-full text-secondary mt-2"></i>
                گزارش خطای درمانگر جدید</span
              >

              <span class="group-icon float-end">
                <i class="fi fi-arrow-start-slim"></i>
                <i class="fi fi-arrow-down-slim"></i>
              </span>
            </button>
          </h2>
        </div> -->
        <p class="justified mb-0">
          مراجع گرامی، تنها کمیته اخلاق کلینیک ارگانیک مایندد متشکل از مدیر‌
          سازمان و مسئول کرسی اخلاق حرفه‌ای کلینیک به اطلاعات این فرم دسترسی
          خواهند داشت و محتوای آن برای همیشه محرمانه خواهد ماند.
        </p>
        <div class="card-body">
          <div class="row justify-content-center">
            <div class="col-md-12 mb-1 p-3 rounded border shadow">
              <combo-box-with-message
                ref="therapistSelect"
                :combo-list="therapistList"
                comboClass="col-md-5 mt-2"
                itemKey="id"
                itemValue="title"
                topTitle="درمانگر:"
                :required="true"
                comboSize="sm"
                topTitleClass="mb-1"
                v-model:selectedItem="entity.therapistID"
                errorText="درمانگر را انتخاب کنید"
                errorClass="text-danger smaller"
                warningSelectRow=""
              />
              <searchable-input
                mode="single"
                placeHolder=""
                errorText="نوع تخطی را انتخاب کنید"
                ref="violationTypeSelect"
                :options="violationTypeList"
                v-model:inputValue="entity.violationTypeID"
                :canDeselect="false"
                :canClear="false"
                topTitle="نوع تخطی:"
                :searchable="false"
                :required="true"
                inputTitle=""
                topTitleClass="mb-1"
                containerClass="mt-2"
              />
              <input-with-message
                copmponentType="textArea"
                containerClass="col-12 mt-2"
                topTitle="توضیحات:"
                inputThem="grayThem"
                :iconSpin="false"
                inputType="text"
                :showMessage="false"
                v-model:inputValue="entity.description"
                :hasSideBox="false"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="m-auto">
        <button
          class="btn btn-sm rounded btn-danger"
          @click="confirmedNewViolationModal"
        >
          <i class="fi fi-box-checked"></i>
          تایید
        </button>
        <button class="btn btn-sm rounded btn-blueSite" @click="cancelModal">
          <i class="fi fi-close"></i>
          انصراف
        </button>
      </div>
    </template>
  </site-modal>

  <div class="mt-2 text-secondary d-md-flex justify-content-end">
    <!-- <div class="display-7" v-if="!isMobile">
      <svg
        class="float-start"
        width="26px"
        height="26px"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
      >
        <path
          d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
        ></path>
        <path
          d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
        ></path>
      </svg>
      گزارش های خطای درمانگران
    </div> -->
    <div class="text-end">
      <button
        class="btn btn-sm w-100 rounded btn-warning"
        @click="addButtonClick"
      >
        ثبت گزارش
      </button>
    </div>
  </div>
  <!-- <hr class="hr-right" /> -->

  <div
    class="row justify-content-center my-3 scrollable-vertical scrollable-styled-dark"
    style="max-height: 70vh"
  >
    <div class="col-12 col-lg-11">
      <div
        class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
        v-for="item in violationReportData"
        :key="item.id"
      >
        <div class="card-body p-lg-3">
          <div class="row g-4 position-relative">
            <div class="col">
              <div class="d-block">
                <span class="d-block">
                  <b>{{ item.therapistName }} </b>
                  <span class="smaller"> (درمانگر)</span>
                </span>
                <span class="d-block smaller justified"
                  ><span class="fw-bold">نوع: </span
                  >{{ item.violationType }}</span
                >
                <!-- <span class="d-block smaller text-muted" v-if="item.id > 0">
                    {{ item.transactionType }}
                    {{ item.transactionType == 'واریز' ? 'به' : 'از' }} کیف پول
                    بابت
                    {{ item.operationType }}
                  </span> -->

                <span class="d-block smaller"
                  ><span class="fw-bold">وضعیت: </span>
                  <span
                    :class="{
                      'text-success': item.violationReportStatusID == 2,
                      'text-danger': item.violationReportStatusID == 1,
                    }"
                    >{{ item.violationReportStatus }}</span
                  >
                </span>

                <div class="mt-2">
                  <a
                    class="small text-secondary"
                    :href="`#collapseDetail_${item.id}`"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    جزئیات
                    <!-- <i class="fi fi-arrow-down-slim"></i> -->
                    <svg
                      width="18px"
                      height="18px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-chevron-compact-down"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-5 col-lg-4 text-start">
              <span class="text-muted smaller" dir="ltr">
                {{ getPersianDateTime(item.createdDate) }}
                <span v-if="isOverseas()">
                  |
                  <small class="gregorianDateClass"
                    >{{ getGregorianDateTime(item.createdDate) }}
                  </small></span
                >
              </span>
              <!-- <div class="flex-none mt-2">
                <a
                  v-if="item.violationReportStatusID == 1"
                  href="#"
                  @click="editViolationReport(item.id)"
                  class="bg-mainPanel text-dark rounded px-2 py-1 small ms-1"
                >
                  <svg
                    width="18px"
                    height="18px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                    ></path>
                  </svg>
                </a>
                <a
                  v-if="item.violationReportStatusID == 1"
                  href="#"
                  @click="deleteViolationReport(item.id)"
                  class="bg-mainPanel text-dark rounded px-2 py-1 small ms-1"
                >
                  <svg
                    width="18px"
                    height="18px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    ></path>
                  </svg>
                </a>
              </div> -->
            </div>
          </div>

          <div class="collapse" :id="`collapseDetail_${item.id}`">
            <div class="card card-body small justified">
              <span class="d-block text-success smaller mb-1"
                ><b>توضیح (مراجع):</b></span
              >
              {{ item.description }}
            </div>
            <div
              class="card card-body small mt-1 justified"
              v-if="item.violationReportStatusID != 1"
            >
              <span class="d-block text-primary smaller mb-1"
                ><b>توضیح (کلینیک):</b></span
              >
              {{ item.verifiedDescription }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
        v-if="violationReportData.length == 0"
      >
        <div class="card-body d-flex justify-content-between">
          <div class="w-100 pt-1 text-center">
            <strong class="d-block fs-6 fw-medium">
              گزارش خطای درمانگر وجود ندارد</strong
            >
          </div>
        </div>
      </div>
      <div class="text-center my-2">
        <button
          class="btn btn-soft btn-light btn-sm text-black"
          @click="moreViolationReportClick"
          v-if="hasMoreRecord"
        >
          <i class="fi fi-plus"></i>
          <span>نمایش بیشتر</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
// import { useRoute } from 'vue-router';
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import ComboBoxWithMessage from '../../../../components/form/comboBoxWithMessage/ComboBoxWithMessage.vue';
import InputWithMessage from '../../../../components/form/inputWithMessage/InputWithMessage.vue';
import SearchableInput from '../../../../components/form/searchableInput/SearchableInput.vue';
import ValidationSummery from '../../../../components/form/errorBox/ValidationSummery.vue';
import { isMobile } from 'mobile-device-detect';

import axios from 'axios';
import { Modal } from 'bootstrap';

export default {
  components: {
    LoadingSpinner,
    ComboBoxWithMessage,
    InputWithMessage,
    SearchableInput,
    ValidationSummery,
  },
  data() {
    return {
      hasMoreRecord: false,
      modalHasError: false,
      // modalDeleteConfirmHasError: false,
      isCreateOprationModal: false,
      modalError: [],
      isMobile: isMobile,
      violationReportData: [],
      therapistList: [],
      violationTypeList: [],
      searchData: {
        personID: 0,
        recordCount: 9,
      },
      addViolationReportModal: new Object(),
      // violationReportDeleteConfirmModal: new Object(),
      entity: {
        id: 0,
        personID: 0,
        therapistID: 0,
        violationTypeID: 0,
        violationReportStatusID: 1,
        description: '',
      },
    };
  },
  methods: {
    async moreViolationReportClick() {
      this.searchData.recordCount += 9;
      await this.getViolationReport();
    },
    addButtonClick() {
      this.isCreateOprationModal = true;
      this.addViolationReportModal.show();
    },
    resetEntity() {
      this.entity = new Object({
        id: 0,
        personID: 0,
        therapistID: 0,
        violationTypeID: 0,
        violationReportStatusID: 1,
        description: '',
      });
      this.$refs.therapistSelect.hideErrorMessage();
      this.$refs.violationTypeSelect.hideErrorMessage();
    },

    getGregorianDateTime(date) {
      // eslint-disable-next-line
      return getGregorianDateTime(date);
    },
    getPersianDateTime(date) {
      /* eslint-disable */
      return (
        new persianDate(new Date(date)).format('L') +
        ' ' +
        `${new persianDate(new Date(date)).format('LT')}`
      );
    },
    validate() {
      if (!this.entity.therapistID) {
        this.$refs.therapistSelect.showErrorMessage();
        this.$refs.therapistSelect.setFocus();
        return false;
      }
      if (!this.entity.violationTypeID) {
        this.$refs.violationTypeSelect.showErrorMessage();
        this.$refs.violationTypeSelect.setFocus();
        return false;
      }
      return true;
    },

    async getViolationReport() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .post('/ST/ViolationReport/GetViolationReportForSite/', that.searchData)
        .then((response) => {
          that.violationReportData = response.data.violationReportData;
          that.hasMoreRecord =
            response.data.allRecourdCount >
            response.data.violationReportData.length;
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `دریافت داده های گزارش خطای درمانگر با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async confirmedNewViolationModal() {
      let that = this;
      that.entity.personID = this.$store.getters.userPersonID;
      if (!that.validate()) {
        return;
      }
      if (that.entity.id > 0) {
        // that.$refs.spinner.show();
        // await axios
        //   .put('/ST/ViolationReport/Edit', that.entity)
        //   .then(async (response) => {
        //     if (!response?.data?.success) {
        //       that.modalHasError = true;
        //       let errorMessages = response.data.errors.map(
        //         (i) => i.errorMessage
        //       );
        //       errorMessages.forEach((item) => {
        //         this.$refs.notification.show({
        //           type: 'error',
        //           title: item,
        //         });
        //       });
        //       that.modalError = errorMessages;
        //       return;
        //     }
        //     if (response?.data?.success) {
        //       this.$refs.notification.show({
        //         type: 'success',
        //         title: 'اطلاعات با موفقیت ویرایش شد',
        //       });
        //       await that.getViolationReport();
        //       that.cancelModal();
        //     }
        //   })
        //   .catch(() => {
        //     this.$refs.notification.show({
        //       type: 'error',
        //       title: `ویرایش اطلاعات با خطا مواجه گردید.`,
        //     });
        //   })
        //   .finally(() => {
        //     this.$refs.spinner.hide();
        //   });
      } else {
        this.$refs.spinner.show();
        await axios
          .post('/ST/ViolationReport/Create', this.entity)
          .then(async (response) => {
            if (!response?.data?.success) {
              that.modalHasError = true;
              let errorMessages = response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                this.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              that.modalError = errorMessages;
              return;
            }
            if (response?.data?.success) {
              this.$refs.notification.show({
                type: 'success',
                title: 'اطلاعات با موفقیت ثبت شد',
              });
              this.cancelModal();
              await that.getViolationReport();
            }
          })
          .catch((error) => {
            if (!error.response.data.success) {
              let errorMessages = error.response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                that.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              if (errorMessages && errorMessages.length > 0) return;
            }
            this.$refs.notification.show({
              type: 'error',
              title: `ثبت اطلاعات با خطا مواجه گردید.`,
            });
          })
          .finally(() => {
            this.$refs.spinner.hide();
          });
      }
    },
    // async editViolationReport(id) {
    //   let that = this;
    //   this.isCreateOprationModal = false;
    //   await axios
    //     .get('/ST/ViolationReport/' + id)
    //     .then((response) => {
    //       that.$data.entity = response.data;
    //       that.addViolationReportModal.show();
    //     })
    //     .catch(() => {
    //       that.$refs.notification.show({
    //         type: 'error',
    //         title: `عملیات ویرایش با مشکل مواجه شد`,
    //       });
    //     });
    // },

    // deleteViolationReport(id) {
    //   this.entity.id = id;
    //   this.violationReportDeleteConfirmModal.show();
    // },
    cancelModal() {
      this.modalHasError = false;
      // this.modalDeleteConfirmHasError = false;
      this.modalError = [];
      this.resetEntity();
      this.addViolationReportModal.hide();
      // this.violationReportDeleteConfirmModal.hide();
    },
    isOverseas() {
      return this.$store.getters.isOverseas == true;
    },
    // async confirmedDeleteModal() {
    //   let that = this;
    //   await axios
    //     .delete('/ST/ViolationReport/Delete/' + that.entity.id)
    //     .then(async () => {
    //       that.$refs.notification.show({
    //         type: 'success',
    //         title: `گزارش خطای درمانگر با موفقیت حذف گردید.`,
    //       });
    //       that.violationReportDeleteConfirmModal.hide();
    //       await that.getViolationReport();
    //     })
    //     .catch((error) => {
    //       if (!error.response.data.success) {
    //         that.modalDeleteConfirmHasError = true;
    //         let errorMessages = error.response.data.errors.map(
    //           (i) => i.errorMessage
    //         );
    //         errorMessages.forEach((item) => {
    //           this.$refs.notification.show({
    //             type: 'error',
    //             title: item,
    //           });
    //         });
    //         this.$refs.notification.show({
    //           type: 'error',
    //           title: `عملیات حذف گزارش خطای درمانگر با مشکل مواجه شد`,
    //         });
    //         that.modalError = errorMessages;
    //       }
    //     });
    // },
  },
  async mounted() {
    let that = this;
    // const route = useRoute();
    that.entity.personID = this.$store.getters.userPersonID;
    that.searchData.personID = this.$store.getters.userPersonID;
    that.addViolationReportModal = new Modal(
      document.getElementById('addViolationReportModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    // that.violationReportDeleteConfirmModal = new Modal(
    //   document.getElementById('violationReportDeleteConfirmModal'),
    //   {
    //     keyboard: false,
    //     backdrop: 'static',
    //   }
    // );

    this.$refs.spinner.show();
    await axios
      .get(
        '/Basic/Therapist/GetClientsTherapists?personID=' + that.entity.personID
      )
      .then((response) => {
        that.therapistList = response.data;
      })
      .catch(() => {
        that.$refs.notification.show({
          type: 'error',
          title: `عملیات دریافت اطلاعات درمانگران با خطا مواجه گردید.`,
        });
      })
      .finally(() => {
        this.$refs.spinner.hide();
      });
    await that.getViolationReport();
    this.$refs.spinner.show();
    await axios
      .get('/ST/ViolationType/GetLookup')
      .then((response) => {
        that.violationTypeList = response.data.map((m) => {
          return { id: m.id, label: m.title };
        });
      })
      .catch(() => {
        that.$refs.notification.show({
          type: 'error',
          title: `عملیات دریافت اطلاعات نوع خطای با خطا مواجه گردید.`,
        });
      })
      .finally(() => {
        this.$refs.spinner.hide();
      });

    this.$violationReportHub.client.on(
      'VerifyViolationReport',
      (violationReport) => {
        if (violationReport.personID == that.$store.getters.userPersonID) {
          let foundReport = that.violationReportData.filter(
            (f) => f.id == violationReport.id
          );
          if (foundReport && foundReport.length > 0) {
            foundReport[0].violationReportStatusID =
              violationReport.violationReportStatusID;
            foundReport[0].verifiedDescription =
              violationReport.verifiedDescription;
            foundReport[0].violationReportStatus =
              violationReport.violationReportStatus;
          }
        }
      }
    );
  },
};
</script>
